"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function xby(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M4.5 5.637C4.5 5.62575 4.6575 5.625 6.6885 5.6265L8.87775 5.62875L10.1227 7.7235L11.3888 9.85425L11.4097 9.8895L11.6077 9.552C11.7158 9.366 11.8043 9.21075 11.8028 9.20625C11.8013 9.20175 11.325 8.39775 10.7452 7.42125C10.1655 6.44475 9.69075 5.6415 9.69075 5.63625C9.69075 5.6265 10.02 5.625 11.9955 5.625C13.275 5.625 14.2995 5.628 14.2995 5.6325C14.2995 5.6475 9.41325 13.9553 9.402 13.9575C9.39375 13.959 8.679 12.7515 6.945 9.80475C5.60025 7.5195 4.5 5.6445 4.5 5.637ZM15.105 5.63025C15.105 5.62725 16.095 5.625 17.3032 5.625H19.5L19.497 5.6415C19.4948 5.65125 18.3998 7.51725 17.064 9.78825C15.4448 12.5385 14.6295 13.9178 14.619 13.9193C14.6093 13.9207 14.3797 13.539 13.6102 12.2438C13.0612 11.3213 12.6105 10.5638 12.6075 10.5623C12.6015 10.5585 12.2078 11.2268 12.2108 11.2358C12.2115 11.2395 12.6637 12.0007 13.2142 12.9277C13.5526 13.4906 13.8851 14.0568 14.2118 14.6265C14.205 14.6528 12.0097 18.3728 12.0007 18.375C11.9865 18.378 9.804 14.67 9.8085 14.6512C9.81225 14.643 15.024 5.76375 15.1042 5.63025H15.105Z", fill: color }));
}
exports["default"] = xby;
//# sourceMappingURL=xby.js.map